<template>
    <div id="auth_result">
        <ul class="cic-container">
            <li class="cic-header">
                <span class="cic-header-title">{{ $t('Authorisation') }}</span>
            </li>
            <li :class="{ success: success }" class="auth-message">
                {{ $t(message) }}
            </li>
            <li class="cic-footer">
                <template v-if="message">
                    <cic-button v-if="url" @click="redirect">
                        {{ $t('Authorise [x]').replace(/\[x]/g, url.address) }}
                    </cic-button>
                    <cic-button v-else @click="handleContinue">
                        {{ $t('Continue') }}
                    </cic-button>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import { post } from '@/utils/Http';

    export default {
        name: 'AuthorisationResult',
        components: {
            CicButton,
        },
        data() {
            return {
                message: '',
                success: false,
                url: null,
            };
        },
        created() {
            const urlParams = new URLSearchParams(window.location.search);
            const state = decodeURIComponent(urlParams.get('state').replace(/\+/g, ' '));
            const code = decodeURIComponent(urlParams.get('code').replace(/\+/g, ' '));

            let urls = JSON.parse(window.localStorage.getItem('email_auth'));
            if (urls && urls.some((x) => x.url.indexOf('state=' + state) !== -1)) {
                let index = urls.findIndex((x) => x.url.indexOf('state=' + state) !== -1);
                this.$store.setShowLoadingOverlay('Saving...');
                post('email/updatetokens', {
                    accessId: urls[index].accessId,
                    address: urls[index].address,
                    code,
                }).then((response) => {
                    this.$store.hideLoadingOverlay();
                    if (response.status === 'OK') {
                        this.success = true;
                        this.message = 'Update successful';
                        if (urls.length > 1) {
                            urls.splice(index, 1);
                            window.localStorage.setItem('email_auth', JSON.stringify(urls));
                            this.url = urls[0];
                        } else {
                            window.localStorage.removeItem('email_auth');
                        }
                    } else {
                        this.url = urls[0];
                        this.message = response.errorMessage;
                    }
                });
            } else {
                this.message = 'Update failed';
            }
        },
        methods: {
            redirect() {
                window.location.assign(this.url.url);
            },
            handleContinue() {
                this.$router.push('/accesspoints');
            },
        },
    };
</script>
